module.exports = __webpack_public_path__ + "static/brian-dennis-e1ad59569493a62184379b4138566000.jpg";